import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Preday from '../days/pre_day';
import Calday from '../days/cal_day';
import DnDday from '../days/dnd_day';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'
import DTBookedShiftPlace from '../dndelements/dtshiftplace'
import DTOfferShiftPlace from '../dndelements/dtofferplace'
import html2canvas from 'html2canvas';
import JSpdf from 'jspdf';
import '../calendar.css';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
// import InputBase from '@material-ui/core/InputBase'
import Input from '@material-ui/core/Input'
import TextField from '@material-ui/core/TextField'
const wota = ['Mo','Di','Mi','Do','Fr','Sa','So']
const monate = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember']

const FT = {'2018':{'10':[3],'11':[1],
'12':[25,26]},'2019':{'01':[1],'04':[19,22],
'05':[1,30],'06':[10,20],'10':[3],'11':[1],'12':[25,26] } }

const style = {
  marginRight :'auto',
  marginLeft : 'auto',

}

const printcontrolbuttons ={
  flexDirection : 'row',
  justifyContent : 'center'
}

const rstyle = {
  height : '20px'
}


class DPprint extends Component {
  //aus parent: selected_user, userdata, monat, jahr, socket
  //holt vom server: current_offers von selected_user
  //an Calday: current_offers[tag], tag
    // zurück offer_day
  //an OfferPopup: current_offers[offer_day], allowed_wp,
    // zurück wp -> shift -> true/false

  constructor(props) {
    super(props)

    //let datum = this.props.datum;
    var datum = '01.09.2018';
    this.state = {
      charge : {},
      response : false,
      offer_day : 0,
      offers : {},
      booked : {},
      td : [],
      nd : [],
      orgl : false,
      bemerkungen : false,
      bemerkungen_list : {},
      orgl_list : {}

    }
}

  firstdayinmonth = () => {    return new Date(this.props.jahr,parseInt(this.props.monat,10)-1,0).getDay()  }
  daysinmonth = () => {    return new Date(this.props.jahr,parseInt(this.props.monat,10),0).getDate()  }
  weekday = (day) => {    return new Date(this.props.jahr,parseInt(this.props.monat,10)-1, day-1).getDay()  }
  dbmonat= () => {    return this.props.monat+'.'+this.props.jahr  }
  stand = (full) => {
    let x = new Date()
    if (full) {return x.getDate()+'.'+(x.getMonth()+1)+'.'+x.getFullYear()+'_'+x.getHours()+'-'+x.getMinutes()}
    else {return x.getDate()+'.'+(x.getMonth()+1)+'.'+x.getFullYear()}
  }
  handleDnD = (data) => {
    this.props.onDnD(data)
  }


  componentDidMount () {
    this.setState({offers :this.props.offers})
    this.setState({booked : this.props.booked})
    let s  = this.props.socket
    s.on('orgl got', data => {
      this.setState({orgl_list : data})
    })
    s.on('notes got', data => {
      console.log(data)
      this.setState({bemerkungen_list : data})
    })
    s.emit('get orgl',{monat : this.dbmonat(),wp : this.props.selected_wp})
    s.emit('get notes',{monat : this.dbmonat(),wp : this.props.selected_wp})
  }

  componentDidUpdate (prevProps) {
    if (this.props !== prevProps) {
      let s = this.props.socket
      this.setState({offers :this.props.offers})
      this.setState({booked : this.props.booked})
      s.emit('get orgl',{monat : this.dbmonat(),wp : this.props.selected_wp})
      s.emit('get notes',{monat : this.dbmonat(),wp : this.props.selected_wp})
      }
  }

  handleNotes = (e,d) => {
    console.log('mod note',e.target.value,d)
    let s = this.props.socket
    s.emit('mod note',{tag:d,wp:this.props.selected_wp,monat:this.dbmonat(),text:e.target.value})

  }

  printDocument=() => {
    const input = document.getElementById('printview');
    html2canvas(input,{scale:3})
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        console.log(canvas)
        const pdf = new JSpdf("p","pt","a4", true);
        const ratio = canvas.width / canvas.height
        console.log(ratio)
        pdf.addImage(imgData, 'png', 65 , 10, 900/2 , ((900/canvas.width) * canvas.height)/2,'','MEDIUM'); ;
        // pdf.output('dataurlnewwindow');
        pdf.save('dp_'+this.dbmonat()+'_'+this.props.selected_wp+'_'+this.stand(true)+'.pdf');
      })
    ;
  }

  render() {
    var plain = [];
    var day = [];

    const head1 = {
      textAlign : 'center'
    }

    const head2 = {
      textAlign : 'center',
      fontSize : '75%'
    }

    const isft = (tag) => {
      if (this.props.jahr in FT && this.props.monat in FT[this.props.jahr]  && FT[this.props.jahr][this.props.monat].indexOf(tag) !== -1 ) {
        return 'wt_FT'
    }
      else {
        return ''
      }
    }

    const lz = (i) => {
      return (i>9 ? i : '0'+i)
    }


     for (let i=0; i<this.daysinmonth();i++) {
        day.push(
            <TableRow key={i} style={rstyle} className={'wt_'+wota[this.weekday(i+1)]+' '+isft(i+1) }>
              <TableCell component="th" scope="row">
                {lz((i+1))+'.'+this.props.monat+', '+wota[this.weekday(i+1)]}
              </TableCell>
              <TableCell>{i+1 in this.state.booked && this.state.booked[i+1] && 'TD' in this.state.booked[i+1]
               && this.state.booked[i+1]['TD'][0] && 'fullname' in this.state.booked[i+1]['TD'][0]? this.state.booked[i+1]['TD'][0].fullname :'' }</TableCell>
              <TableCell>{i+1 in this.state.booked && this.state.booked[i+1] && 'ND' in this.state.booked[i+1]
               && this.state.booked[i+1]['ND'][0] && 'fullname' in this.state.booked[i+1]['ND'][0] ? this.state.booked[i+1]['ND'][0].fullname : '' }</TableCell>
               {this.props.selected_wp == 'LNA_HS' && this.state.orgl && <TableCell>{this.state.orgl_list && i+1 in this.state.orgl_list && this.state.orgl_list[i+1].user}</TableCell>}
               {this.state.bemerkungen && <TableCell><TextField multiline onBlur={e => this.handleNotes(e,i+1)} defaultValue={(this.state.bemerkungen_list && ''+(i+1) in this.state.bemerkungen_list) ? this.state.bemerkungen_list[i+1].text : ''}/></TableCell>}
            </TableRow>
            )
        }



    return (
      <div style={style}>
      {this.props.selected_wp == 'LNA_HS' &&
      <FormGroup style={printcontrolbuttons}>
      <FormControlLabel
          control={
            <Switch
              checked={this.state.orgl}
              onChange={e => this.setState({orgl : !this.state.orgl})}
            />
          }
          label="Orgl"
        />
        <FormControlLabel
          control={
            <Switch
              checked={this.state.bemerkungen}
              onChange={e => this.setState({bemerkungen : !this.state.bemerkungen})}
            />
          }
          label="Bemerkungen"
        />
      </FormGroup>
    }   
    <Button variant="contained" color="primary" onClick={() => this.printDocument()}>
      Drucken
    </Button>
      <div id="printview" className="Liste" style={style}>
      <Paper>
      <Typography variant='headline' component='h3' style={head1} onClick={() => this.printDocument()}>
        {monate[parseInt(this.props.monat,10)-1] +' '+this.props.jahr}
      </Typography>
      <Typography variant='headline' component='h5' style={head2}>
        {'Stand: '+this.stand(false)}
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Datum</TableCell>
            <TableCell>Tagdienst</TableCell>
            <TableCell>Nachtdienst</TableCell>
            {this.props.selected_wp == 'LNA_HS' && this.state.orgl && <TableCell>Orgl</TableCell>}
            {this.state.bemerkungen && <TableCell>Bemerkungen</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
        {day}
        </TableBody>
      </Table>
    </Paper>
      </div>
      </div>
    );
  }
}

DPprint.propTypes = {
  userdata: PropTypes.object.isRequired
};



export default DPprint;
